import React, { ReactNode, RefObject } from 'react';
import CopyLinkButton from './CopyLinkButton';
import ResultImageExport from './ResultImageExport';
import { useSharedReportView } from '../../routing';

interface TbcPhaseHeaderProps {
    title: string;
    backLabel: string;
    onBack: () => void;
    help?: ReactNode;
    /** Results container to capture for the image export buttons. */
    exportTarget?: RefObject<HTMLElement>;
    /** Show a copy-link button: the current URL rebuilds this report when opened elsewhere. */
    shareable?: boolean;
}

function exportFileName(title: string): string {
    const slug = title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
    return `${slug}-${new Date().toISOString().slice(0, 10)}.png`;
}

const TbcPhaseHeader: React.FC<TbcPhaseHeaderProps> = ({ title, backLabel, onBack, help, exportTarget, shareable }) => {
    const sharedReportView = useSharedReportView();
    return (
        <div className="phase-header">
            <h3 className="heading-with-help">
                {title}
                {help && <span data-export-ignore>{help}</span>}
            </h3>
            <div className="phase-header-actions" data-export-ignore>
                {shareable && <CopyLinkButton />}
                {exportTarget && <ResultImageExport target={exportTarget} fileName={exportFileName(title)} />}
                {!sharedReportView && (
                    <button type="button" onClick={onBack} className="back-button">
                        {backLabel}
                    </button>
                )}
            </div>
        </div>
    );
};

export default TbcPhaseHeader;
